import { useEffect, useState, useContext } from "react";
import Billimg from "../components/Billimg";
import { MdArrowForwardIos, MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { Row, Col } from "react-bootstrap";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { Link } from "react-router-dom";
import { TbPigMoney } from "react-icons/tb";
import { RiBuildingLine } from "react-icons/ri";
import EfectivoImg from "../components/EfectivoImg";
import { ThemeContext } from "../App";
import { useThemeManager } from "../Hooks/ThemeManager";

const Efectivo = () => {
  const { themeColors } = useThemeManager();

  const formasDePago = [
    {
      id: 1,
      icono: <RiBuildingLine className="iconDetails me-3" />,
      titulo: "Pago en oficina",
      descripcion: "Establece una promesa de pago",
      link: "/oficina",
    },
  ];

  return (
    <>
      <div className="header-pago">
        <Link to="/pago" className="back">
          <div className="color-primary">
            <MdOutlineKeyboardArrowLeft className="btn-back" />
          </div>
          <div>
            <span>Volver</span>
          </div>
        </Link>
      </div>
      <div className="containerPagos color-secondary">
        <div className="pagosContainer">
          <span className="tituloRealizar">Realizar pagos en efectivo</span>
          <span className="mb-4">Seleccione la opción que desea utilizar</span>
          {formasDePago.map((forma) => (
            <div className="formasBorder all-border">
              <Link to={forma.link} className="pointer color-primary">
                <Row className="formasPago" key={forma.id}>
                  <Col xs={10} sm={11} className="col-metodo-2">
                    <div className="p-2">{forma.icono}</div>
                    <div className="col-metodo">
                      <span className="titulo-pago">{forma.titulo}</span>
                      <span>{forma.descripcion}</span>
                    </div>
                  </Col>
                  <Col xs={2} sm={1} className="iconPago">
                    <MdArrowForwardIos size={25} className="iconPago-size" />
                  </Col>
                </Row>
              </Link>
            </div>
          ))}
        </div>
        <div className="side-image">
          <EfectivoImg theme={themeColors} />
        </div>
      </div>
    </>
  );
};

export default Efectivo;
